import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getCookie } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import Drawer from '../Drawer/Drawer';
import OwedPayments from './OwedPayments';
import UpcomingSessions from './UpcomingSessions';
import ReviewPackages from './ReviewPackages';
import PendingSessions from '../Sessions/PendingSessions';

const Dashboard = observer(class Dashboard extends React.Component {
  constructor() {
    super();
    this.renderReviewPackages = this.renderReviewPackages.bind(this);
  }

  componentWillMount() {
    this.state = {
      drawerOpen: false,
      drawerContent: null,
      messageThreadSid: null
    }

    const { PaymentStore, ReviewStore, ScheduleStore, SessionStore } = this.props.store;

    let token = null;
    let userData = null;

    if(SessionStore.hasSessionStorage) {
      token = sessionStorage.getItem('token');
      userData = sessionStorage.getItem('userData');
    } else {
      token = getCookie('token');
      userData = getCookie('userData');
    }

    if(token && userData) {
      PaymentStore.getBalance();
      ScheduleStore.getSessions(3, 'Scheduled');
      ReviewStore.getCurrentReviewPackage();
    }
  }

  renderResults() {
    const { SessionStore } = this.props.store;

    if(SessionStore.loadingCalls.indexOf('GetBalance') < 0 && SessionStore.loadingCalls.indexOf('GetSessions') < 0) {
      return (
        <ul className="panel-list">
          <li>
            <OwedPayments {...this.props} />
          </li>
          <li>
            <UpcomingSessions {...this.props} />
          </li>
        </ul>
      )
    }

    return '';
  }

  renderReviewPackages() {
    const { ReviewStore } = this.props.store;

    return (
      <div>
        {ReviewStore.packages.length > 0 &&
          <ReviewPackages {...this.props} />
        }
      </div>
    )
  }

  render() {
    const { ReviewStore, SessionStore } = this.props.store;

    return(
      <main tabIndex="0" id="main-content" className="page">
        <div className="wrap">
          <section className="page__section">
            {this.renderResults()}
          </section>

          {(!SessionStore.loading || ReviewStore.packages.length > 0) &&
            <section className="page__section">
              <FeatureFlag
                flagKey="review-packages"
                renderFeatureCallback={this.renderReviewPackages}
              />
            </section>
          }

          <section className="page__section">
            <PendingSessions
              parent={this}
              {...this.props}
            />
          </section>
        </div>

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          messageSid={this.state.messageThreadSid}
          pending={true}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('Dashboard')(Dashboard);



// WEBPACK FOOTER //
// ./src/app/components/Dashboard/Dashboard.js